import { useSelector } from "react-redux";
import { useSite } from "../../../../context/TranslationContext";
import styles from "./ServicesNetworkSection.module.scss";
import { RootState } from "../../../../redux/store";
const ServicesNetworkSection = () => {
  const { data } = useSelector((state: RootState) => state.translationData);
  return (
    <div id={styles.services_network}>
      <div className="container">
        <div className={styles.services_network}>
          <h1 className={styles.section_title}>{data?.service_networks}</h1>
          <div className={styles.map}>
            <iframe
              height="600"
              width="100%"
              frameBorder="0"
              scrolling="no"
              marginHeight={0}
              marginWidth={0}
              // style={{ borderRadius: "30px" }}
              className={styles.iframe}
              color="black"
              title="Nizami Gəncəvi parkı location map"
              src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=az&amp;q=Colibri%20Express&amp;t=&amp;z=19&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
            >
              <a href="https://www.gps.ie/">gps tracker sport</a>
            </iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesNetworkSection;
